import { createSlice } from "@reduxjs/toolkit";
import Branch from "../../models/branch.model";
import News from "../../models/news.model";
import PD from "../../models/pressrelease-downloads.model";



export interface searchStoreInterface {
  searches:{
    news:Array<News>,
    notices:Array<News>,
    branches:Array<Branch>,
    press_releases:Array<PD>,
  } | undefined,
  searching:boolean,
  error:any,
  keyword:string|null
}


const initialState:searchStoreInterface = {
  searches:undefined,
  error:undefined,
  searching:false,
  keyword:null
}


const searchSlice = createSlice(
  {
    name:'search',
    initialState:initialState,
    reducers:{
      searchRequest(state){
        state.searching = true;
      },

      searchSuccess(state,actions){
        state.searching = false;
        state.searches = actions.payload.searches;
        state.keyword = actions.payload.keyword;
      },

      searchFail(state,actions){
        state.searching = false;
        state.error = actions.payload;
      }
    }
  }
)

export const {
  searchFail,
  searchRequest,
  searchSuccess
} = searchSlice.actions;

export default searchSlice.reducer;